<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 3
      h1 Gestión centrada en la persona
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-12
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img1.jpg" alt="Imagen decorativa")
    p.mb-0(data-aos="fade-left") La gestión centrada en la persona constituye un enfoque fundamental en el sector salud, orientado a garantizar una atención integral que reconozca a cada individuo como un ser único, con necesidades, valores, expectativas y contextos propios. Este modelo trasciende la visión tradicional centrada exclusivamente en la enfermedad, para situar a la persona como eje del proceso de atención, promoviendo el respeto por su dignidad, autonomía y participación activa en la toma de decisiones. Desde esta perspectiva, la gestión en salud articula aspectos clínicos, organizacionales y relacionales, fortaleciendo prácticas humanizadas que integran el saber técnico con las dimensiones emocionales, sociales y culturales, contribuyendo así a mejorar la calidad del cuidado y la experiencia de las personas y sus redes de apoyo.

    separador
    #t_3_1.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  3.1	Antecedentes del modelo de atención centrada en la persona
    p.mb-4(data-aos="fade-left") En el desarrollo del presente apartado se toman los aportes de autores destacados, con el propósito de recordar las contribuciones que han influido de manera significativa en el modelo de atención centrada en la persona y en su aplicación actual como expresión de la humanización en el sector salud y en la atención en salud.

    .row.tarjeta--BMG5.justify-content-center.align-items-center.mb-5
      .col-lg-5
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img2.png" alt="Imagen decorativa" style="margin-left: -12px;")
      .col-lg-7
        .row
          .col-2.d-lg-block.d-none
            figure.mb-4(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema3/img3.svg" alt="Imagen decorativa")

        p.mb-0(data-aos="fade-left") Por lo tanto, es importante mencionar que han transcurrido más de 60 años desde que Carl Rogers (1902–1987) propuso la terapia centrada en la persona (1951); sin embargo, sus investigaciones y planteamientos continúan siendo vigentes. Este enfoque considera a la persona en su totalidad y resalta la influencia de los aspectos somáticos y psicológicos en la salud. Inicialmente, Rogers denominó este modelo como terapia centrada en el cliente, argumentando que quien solicita apoyo profesional se sitúa en una relación de servicio; posteriormente, el término evolucionó hacia “persona”, con el fin de resaltar una mirada holística e integral del ser humano.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 La persona como centro

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-7.order-2.order-lg-1(data-aos="fade-left")
        p La terapia centrada en la persona, considera que los seres humanos son incondicionalmente válidos, independientemente de su comportamiento, condición o sentimientos.
        .row.justify-content-center.align-items-center.mb-4
          .col-lg-2.d-lg-block.d-none
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema3/img4.svg" alt="Imagen decorativa")
          .col-lg-10
            p.mb-0 En un contexto en que la persona se considere valorada, abandona las actitudes defensivas y gradualmente se vuelve capaz de escucharse a sí mismo y se abre a sentimientos de coraje, ternura y fervor. Para el autor "la persona es lo que es, en profundidad, es una experiencia enriquecedora".
        p.mb-0 Los siguientes se consideran procesos esenciales, basados en la perspectiva rogeriana:
      .col-lg-5.col-6.order-1.order-lg-2
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img5.jpg" alt="Imagen decorativa")
    
    .row.justify-content-center.align-items-center
      .col-lg-10
        PasosA.color-acento-contenido.mb-5(tipo="n")
          .row(titulo="")
            .col-lg-10.mb-4.mb-md-0(data-aos="fade-left")
              h5  Estimación positiva incondicional
              p.mb-0  Implica aceptar y valorar a la persona en su totalidad, sin juicios ni condiciones, reconociendo su dignidad y valor intrínseco. En el contexto de la atención en salud, este proceso permite que el paciente se sienta respetado y comprendido, lo que reduce actitudes defensivas y favorece un clima de confianza.
            .col-lg-2.d-none.d-lg-block
              figure.mb-4(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img6.svg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-2.d-none.d-lg-block
              figure.mb-4(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img7.svg" alt="Imagen decorativa")
            .col-lg-10.mb-4.mb-md-0(data-aos="fade-left")
              h5  Empatía
              p.mb-0  Consiste en comprender profundamente el mundo interno de la persona, percibiendo sus emociones, pensamientos y significados como si fueran propios, sin perder la condición de profesional. En la atención en salud, esta capacidad permite interpretar adecuadamente las vivencias del paciente frente a la enfermedad y el tratamiento, promoviendo una comunicación más cercana y efectiva.
          .row(titulo="")
            .col-lg-10.mb-4.mb-md-0(data-aos="fade-left")
              h5  Congruencia
              p.mb-0  Una persona que encuentra la congruencia entre su “yo ideal” y su “yo real” es menos propensa a vivenciar desequilibrios sicológicos. Por ello el terapeuta debería propiciar experiencias que permitan que el paciente estructure mejores visiones de sí mismo y su salud.
            .col-lg-2.d-none.d-lg-block
              figure.mb-4(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img8.svg" alt="Imagen decorativa")
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .cajon.color-primario.p-4.mb-4
          .row.justify-content-center.align-items-center
            .col-lg-2.d-none.d-lg-block
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img9.svg" alt="Icono 1")
            .col-lg-10
              p.mb-0 Rogers considera que un terapeuta necesita ser auténtico y entregarse por completo a la relación profesional del paciente, para lograr mayor efectividad.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Rol activo del paciente
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-1.d-lg-block.d-none
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img10.svg" alt="Imagen decorativa")
      .col-lg-11(data-aos="fade-left")
        p Este contexto le permite al paciente explorar su propia forma de ser y su complejidad, quien dentro de un contexto de atención en salud, conoce mejor sus problemas, lo que le lastima y lo que le ayudaría a solucionar.
        p.mb-0 Los principales cambios observados por Rogers en los pacientes, durante o después del final del proceso de terapia son:

    .BMG1.px-lg-4.p-4
      .row.justify-content-center.align-items-center.mb-4
        .col-lg-3.col-6.mb-4.mb-lg-0
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img11.svg" alt="Icono 1")
        .col-lg-8.mb-4.mb-lg-0(data-aos="fade-left")
          ol.lista-ol--cuadro.lista-ol--separador
            li(data-aos="fade-left") 
              .lista-ol--cuadro__vineta
                span 1
              p.mb-0 Se obtiene una nueva perspectiva sobre la libertad y el determinismo.
            li(data-aos="fade-left") 
              .lista-ol--cuadro__vineta
                span 2
              p.mb-0 Usa la creatividad como elemento de la vida plena. 
            li(data-aos="fade-left") 
              .lista-ol--cuadro__vineta
                span 3
              p.mb-0 Pueden vivir en cualquier momento y cultura. 
            li(data-aos="fade-left") 
              .lista-ol--cuadro__vineta
                span 4
              p.mb-0 Comienzan a vivir de manera constructiva; es decir, siempre continúan progresando para ser ellos mismos.
            li(data-aos="fade-left") 
              .lista-ol--cuadro__vineta
                span 5
              p.mb-0 Comportarse lo más completamente posible para satisfacer sus necesidades.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Modelo biopsicosocial
    p(data-aos="fade-left") Georges Engel, reconocido como el creador del modelo biopsicosocial, propone un enfoque que comprende a la persona como un ser integral, en el cual la dimensión psicológica constituye un componente esencial en la experiencia de la enfermedad. Este modelo destaca la importancia del contexto emocional y social en el que vive la persona, reconociendo que los factores psicológicos influyen en los procesos biológicos y que estos, a su vez, impactan el sistema social del paciente. El modelo biopsicosocial enfatiza una visión amplia e integrada de la salud, la enfermedad y la atención, con el propósito de evidenciar la interrelación entre las creencias familiares y la forma en que las personas y sus familias se adaptan a los procesos de enfermedad.
    p.mb-4(data-aos="fade-left") Basado en Borrell-Carrió (2002), sus fundamentos son:

    .tarjeta--BMG4.p-5.mb-5
      .tarjeta.tarjeta--gris.p-4
        PasosB.color-acento-contenido
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img12.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              p.mb-0 Una alteración bioquímica no siempre se traduce en enfermedad. Esta aparece por la interrelación de diversas causas, no solo moleculares, sino también psicológicas y sociales. A la inversa: de alteraciones psicosociales pueden derivarse enfermedades o «dolencias» que constituyen problemas de salud, incluso a veces con correlación bioquímica.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img13.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              p.mb-0 La simple anomalía biológica no arroja ninguna luz sobre el significado de los síntomas para el paciente, ni asegura tampoco las actitudes y habilidades del clínico para recoger la información y procesarla de manera adecuada.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img14.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              p.mb-0 Las variables de índole psicosocial suelen ser importantes a la hora de determinar la susceptibilidad, gravedad y curso del padecimiento más biológico que pudiera considerarse.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img15.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              p.mb-0 La aceptación del rol de enfermo no viene determinada de manera mecánica por la presencia de una anomalía biológica.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img16.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              p.mb-0 El tratamiento biológico puede tener diversas tasas de éxito influido directamente por variables psicosociales, tal como deja patente el llamado efecto placebo, entre otros.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img17.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              p.mb-0 Además, la relación del profesional de la salud con el paciente, también interviene en el resultado terapéutico, aunque solo sea por la influencia que pueda tener sobre el cumplimiento del tratamiento. 

    p.text-center.mb-4(data-aos="fade-left") Igualmente, existen los siguientes aspectos favorables de la perspectiva (biopsicosocial):
    .tarjeta--BMG6.pt-4.px-4
      .row.justify-content-center.align-items-center.mb-5
        .col-lg-3.d-lg-block.d-none
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img18.png" alt="Imagen decorativa")
        .col-lg-9
          SlyderF.mb-5(columnas="col-lg-6 col-xl-4")
            .tarjeta.tarjeta-fblanco.p-4
              .row.justify-content-center.mb-3
                .col-5
                  img(src='@/assets/curso/temas/tema3/img19.svg' alt='AvatarTop')
              p.text-center Estimula a un conocimiento más integral del paciente y su entorno.
            .tarjeta.tarjeta-fblanco.p-4
              .row.justify-content-center.mb-3
                .col-5
                  img(src='@/assets/curso/temas/tema3/img20.svg' alt='AvatarTop')
              p.text-center Integra los hallazgos en las tres esferas: biológica, psicológica y social.
            .tarjeta.tarjeta-fblanco.p-4
              .row.justify-content-center.mb-3
                .col-5
                  img(src='@/assets/curso/temas/tema3/img21.svg' alt='AvatarTop')
              p.text-center Reconoce el papel central que desempeña la relación terapéutica en el curso de los acontecimientos.
            .tarjeta.tarjeta-fblanco.p-4
              .row.justify-content-center.mb-3
                .col-5
                  img(src='@/assets/curso/temas/tema3/img22.svg' alt='AvatarTop')
              p.text-center Optimiza el trabajo en equipo.
            .tarjeta.tarjeta-fblanco.p-4
              .row.justify-content-center.mb-3
                .col-5
                  img(src='@/assets/curso/temas/tema3/img23.svg' alt='AvatarTop')
              p.text-center Incorpora al profesional de salud como una pieza más del sistema que también debe ser cuidada.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Características
    p.mb-4(data-aos="fade-left") Este modelo comienza a fundamentarse con las teorías de terapias familiares y luego son orientadas a entender los aspectos biopsicosociales que presenta el individuo cuando la atención médica está centrada en la familia, creando la terapia médica familiar. Por ello, se caracteriza principalmente por:

    SlyderF.mb-5(columnas="col-lg-6 col-xl-4")
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema3/img24.svg' alt='AvatarTop')
        h5.text-center Integración cuerpo–mente
        p.text-center Reconoce la interacción permanente entre los procesos físicos y psicológicos del individuo, comprendiendo que ambos influyen de manera conjunta en la salud, la enfermedad y el bienestar.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema3/img25.svg' alt='AvatarTop')
        h5.text-center Influencia de la dinámica familiar en la salud
        p.text-center Analiza cómo las relaciones familiares, las pautas de convivencia y los estilos de vida influyen en la adopción y mantenimiento de hábitos saludables.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema3/img26.svg' alt='AvatarTop')
        h5.text-center Relación persona–familia–entorno social
        p.text-center Considera la interdependencia entre la salud individual, el bienestar familiar, la relación terapéutica entre el profesional y el paciente, y el contexto social en el que se desarrolla la atención.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema3/img27.svg' alt='AvatarTop')
        h5.text-center Atención centrada en la familia y comunicación
        p.text-center Orienta la atención sanitaria hacia la participación activa de la familia, fortaleciendo la comunicación y el acompañamiento profesional mediante procesos de asesoramiento colaborativo.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema3/img28.svg' alt='AvatarTop')
        h5.text-center Apoyo emocional y cuidado en el contexto familiar
        p.text-center Promueve intervenciones ajustadas a las necesidades emocionales y de salud de las personas, reconociendo a la familia como un espacio fundamental de apoyo y contención.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema3/img29.svg' alt='AvatarTop')
        h5.text-center La familia como sistema promotor de salud
        p.text-center Concibe a la familia como un sistema interrelacionado que participa de manera conjunta en la construcción de hábitos saludables, como estrategia clave para la promoción de la salud.

    .tarjeta.color-acento-botones.p-3(data-aos="fade-right")
      .row.justify-content-around.align-items-center
        .col-3.col-sm-2.col-lg-1
          img(src="@/assets/curso/temas/tema3/img30.svg")
        .col
          .row.justify-content-between.align-items-center
            .col.mb-sm-0.mb-4
              h3.mb-1 El modelo biopsicosocial en evolución
              p Para profundizar en la reflexión de las relaciones de los anteriores modelos, acceda al siguiente documento que detalla con mayor profundidad esta temática.
            .col-sm-auto
              a.boton.color-acento-botones(:href="obtenerLink('/downloads/Anexo_1_El_modelo_biopsicosocial.pdf')" target="_blank" type="application/pdf")
                span Descargar
                i.fas.fa-file-download
    separador
    #t_3_2.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  3.2	Modelo de atención centrada en la persona
    p.mb-4(data-aos="fade-left") La perspectiva mostrada desde el modelo biopsicosocial o la terapia centrada en la persona, establece puntos de discusión que muestran la necesidad de incorporar al paciente como ser humano y a sus cercanos, familiares o agentes de cuidado, como seres activos, partícipes y agentes influyentes en el proceso de salud.

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10(data-aos="fade-left")
        .bloque-texto-c.tarjeta--celeste.p-4
          i.fas.fa-quote-left
          p.text-bold.ms-2.mb-0 Dar la palabra al paciente, dejarle participar en las decisiones, averiguar las expectativas que tiene, mostrar el profesional como ser humano, son puntos capitales del modelo
          br
          span - Borrell-Carrió, 2002
          .d-flex.justify-content-end.align-items-center(style="margin-top:-35px")
              i.fas.fa-quote-right


    .row.justify-content-center.align-items-center.mb-4
      
      .col-lg-9.mb-4.mb-lg-0
        .row.justify-content-center.mb-3
          .col-lg-2.d-none.d-lg-block
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema3/img32.svg" alt="Icono 1"  class="m-auto" style="width: 100px;")
          .col-lg-10
            p.mb-0(data-aos="fade-left") El modelo centrado en la persona constituye una estrategia fundamental de gestión para la humanización en salud. Si bien existen diversas interpretaciones sobre este enfoque, una de las principales reconoce que la humanización rescata lo más genuino y natural del ser humano, valorando a cada persona desde sus capacidades y promoviendo el fortalecimiento de habilidades propias del talento humano en salud.
        .cajon.color-secundario.p-4.mb-4
          p.mb-0(data-aos="fade-left")  Centrarse en la persona implica fortalecer de manera cotidiana la misión humana del cuidado, el espíritu de servicio y los valores personales, así como reorganizar o construir modelos de atención que orienten sus esfuerzos hacia las necesidades reales de las personas y de su red de apoyo.
        p.mb-0 A continuación, se presentan diversas formas de abordar la gestión de la humanización, a partir de experiencias y estrategias desarrolladas por organizaciones nacionales e internacionales en el ámbito de la atención en salud:
      .col-lg-3.col-6.mb-4.mb-lg-0.order-1.order-lg-2
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img33.png" alt="Icono 1")
    
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Modelo OMS
    p.mb-4 La Organización Mundial de la Salud (OMS), plantea el siguiente modelo de atención centrada en la persona, teniendo en cuenta las necesidades integrales de las personas y las comunidades como el centro del sistema de salud, no solamente desde la enfermedad. Además, propone capacitar a las personas para que tengan un papel más activo en su propia salud:
    
    .row.justify-content-center.align-items-center
      .col-lg-10
        .titulo-sexto.color-primario(data-aos="fade-left")
          h5 Figura 1. 
          span Modelo OMS
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-10.movil(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema3/img34_1.svg', alt='Figura 1 que relaciona el modelo de la OMS el cual se basa en la atención centrada en la persona, destacando la situación del país y sus niveles de desarrollo en cuento al sector de salud, la prestación de servicios y los otros sectores en lo que está presente la persona, su familia, la comunidad y los servicios sociales recibidos.')
      .col-lg-10.desktop(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema3/img34.svg', alt='Figura 1 que relaciona el modelo de la OMS el cual se basa en la atención centrada en la persona, destacando la situación del país y sus niveles de desarrollo en cuento al sector de salud, la prestación de servicios y los otros sectores en lo que está presente la persona, su familia, la comunidad y los servicios sociales recibidos.')

    
    p.mb-4 Asimismo, la OMS propone 5 objetivos estratégicos que son interdependientes para que la administración, aseguramiento, financiación, gestión, suministro, prestación, servicios y atención en salud se pueda centrar e integrar en las personas:
    
    .row.justify-content-center.align-items-center.mb-3
      .col-lg-10.desktop
        ImagenInfograficaB.color-acento-botones.mb-5
          template(v-slot:imagen)
            figure
              img(src='@/assets/curso/temas/tema3/img36.svg', alt='imagen decorativa')
          div(x="50%" y="20%" tooltip="Empoderar y comprometer a las personas" numero="+")
            .row.justify-content-center.align-items-center.mt-5
              .col-lg-3.d-none.d-lg-block
                figure(data-aos="zoom-in")
                  img.img-fluid(src="@/assets/curso/temas/tema3/img36_2.svg" alt="Icono 1")
              .col-lg-7
                .h5.mb-2 Empoderar y comprometer a las personas
                p.mb-0 Hace referencia a involucrar, capacitar y proporcionar las oportunidades y recursos necesarios para que las personas participen activamente como usuarias de los servicios de salud. Este enfoque también busca llegar a los grupos poblacionales en situación de vulnerabilidad, con el fin de garantizar el acceso universal a los servicios. Su objetivo es fortalecer la capacidad de las personas para tomar decisiones informadas sobre su propia salud y promover la participación de las comunidades en la coproducción de entornos saludables, la prestación de servicios en articulación con el sector salud y otros sectores, así como en la formulación de políticas públicas.
          
          div(x="35.5%" y="37%" tooltip="Crear un entorno propicio" numero="+")
            .row.justify-content-center.align-items-center.mt-5
              .col-lg-3.d-none.d-lg-block
                figure(data-aos="zoom-in")
                  img.img-fluid(src="@/assets/curso/temas/tema3/img36_3.svg" alt="Icono 1")
              .col-lg-7
                .h5.mb-2 Crear un entorno propicio
                p.mb-0 Para que las estrategias anteriores se consoliden como una realidad operativa, es necesario crear un entorno que facilite la participación y articulación de los diferentes actores involucrados. Este proceso implica transformaciones en los marcos normativos, los mecanismos de financiación, los incentivos institucionales, la organización de la fuerza laboral y la formulación de políticas públicas que respalden un cambio sostenible en la atención en salud.

          div(x="32%" y="73%" tooltip="Coordinación de servicios" numero="+")
            .row.justify-content-center.align-items-center.mt-5
              .col-lg-3.d-none.d-lg-block
                figure(data-aos="zoom-in")
                  img.img-fluid(src="@/assets/curso/temas/tema3/img36_4.svg" alt="Icono 1")
              .col-lg-7
                .h5.mb-2 Coordinación de servicios
                p.mb-0 Hace referencia a la organización y articulación de la atención en torno a las necesidades y preferencias de las personas en todos los niveles del sistema de salud. Asimismo, promueve la integración de los distintos prestadores y la creación de redes efectivas entre el sector salud y otros sectores, mediante la alineación y armonización de procesos que mejoren la continuidad y calidad de la atención.

          div(x="64.5%" y="37%" tooltip="Fortalecimiento de la gobernanza y la rendición de cuentas" numero="+")
            .row.justify-content-center.align-items-center.mt-5
              .col-lg-3.d-none.d-lg-block
                figure(data-aos="zoom-in")
                  img.img-fluid(src="@/assets/curso/temas/tema3/img36_5.svg" alt="Icono 1")
              .col-lg-7
                .h5.mb-2 Fortalecimiento de la gobernanza y la rendición de cuentas
                p.mb-0 Este proceso implica mejorar el diálogo en torno a las políticas públicas, así como la formulación, implementación y evaluación de estas, en conjunto con ciudadanos, comunidades y otras partes interesadas. Busca promover la transparencia en la toma de decisiones y consolidar sistemas sólidos de rendición de cuentas para responsables políticos, directivos, prestadores de servicios y usuarios del sistema de salud.

          div(x="68%" y="73%" tooltip="Reorientar el modelo de atención" numero="+")
            .row.justify-content-center.align-items-center.mt-5
              .col-lg-3.d-none.d-lg-block
                figure(data-aos="zoom-in")
                  img.img-fluid(src="@/assets/curso/temas/tema3/img36_6.svg" alt="Icono 1")
              .col-lg-7
                .h5.mb-2 Reorientar el modelo de atención
                p.mb-0 Se refiere al aseguramiento de la compra y la prestación de servicios de salud eficientes y efectivos, mediante modelos de atención que prioricen la atención primaria, comunitaria y la coproducción de la salud. Este proceso incluye el tránsito de un enfoque centrado en la atención hospitalaria hacia modelos ambulatorios e integrales, más cercanos a las necesidades de las personas y las comunidades.
      .col-lg-10.movil
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img37.svg" alt="Icono 1")

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Perspectiva OES
    p.mb-4 Según la Organización para la Excelencia en Salud (OES) refiere que, para garantizar la mejor atención al paciente se debe contar:

    .row.mb-5
      .col-lg-6.mb-lg-0.mb-4(data-aos="fade-left")
        .tarjeta.tarjeta--BG06.h-100
          figure
            img(src='@/assets/curso/temas/tema3/img38.png', alt='Texto que describa la imagen')
          .p-4
            h5 Atención centrada en el paciente y su familia
            p.mb-0 Necesariamente, la atención debe centrarse en el paciente y su familia como eje fundamental y conceptual del Sistema Obligatorio de Garantía de la Calidad (SOGC).
      .col-lg-6(data-aos="fade-right")
        .tarjeta.tarjeta--BG06.h-100
          figure
            img(src='@/assets/curso/temas/tema3/img39.png', alt='Texto que describa la imagen')         
          .p-4
            h5 Participación activa en la toma de decisiones
            p.mb-0 Es imperativo involucrar al paciente y a su familia en todo el proceso de atención, especialmente en la toma de decisiones relacionadas con el cuidado y el manejo de la enfermedad.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Modelo Organización Planetree
    P Según la Organización Planetree International, plantea que la atención centrada en la persona es más que hospitalidad, ambiente saludable y #[i confort], el cual crea impresiones positivas y experiencias satisfactorias en favor de la calidad de vida.
    P.mb-4 El modelo contribuye a la implementación sistemática de la humanización en la atención centrada en la persona y su familia, la cual se aborda de la siguiente manera:
    
    .tarjeta--BMG4.p-5.mb-4 
      .tarjeta.tarjeta--gris.p-4
        PasosB.color-acento-contenido
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img40.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Orientación del liderazgo
              p.mb-0 Promueve líderes capaces de inspirar y establecer vínculos efectivos con el personal, facilitando la apropiación del enfoque y su integración como parte del abordaje estratégico de las organizaciones.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img41.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Planetree para el personal
              p.mb-0 Se centra en el cuidado y reconocimiento de las personas que contribuyen al bienestar y la salud, valorando sus logros, buenas prácticas y el impacto positivo de su labor en el fortalecimiento de la atención centrada en la persona.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img42.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Evaluación cultural
              p.mb-0 Implica la aplicación de encuestas de cultura organizacional que permitan identificar creencias, prácticas y acciones con impacto positivo, con el fin de construir planes de mejora inclusivos y colectivos, con la participación del personal administrativo y asistencial, así como de las personas y sus familias.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img43.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Desarrollo de programas
              p.mb-0 Consiste en el diseño e implementación de programas prioritarios y preferenciales que resulten significativos y atractivos para las personas, fortaleciendo su experiencia en los servicios de salud.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img44.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Implementación de prácticas adecuadas para pacientes
              p.mb-0 Hace referencia a la planificación, dirección y gestión de procesos orientados a implementar y fortalecer programas centrados en el cuidado de las personas.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img45.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Entrenamiento gerencial
              p.mb-0 Se orienta a identificar las necesidades de #[i coaching] de gerentes y directivos, así como a desarrollar nuevas estrategias de motivación, involucramiento y capacitación del personal, definiendo roles claros dentro de una nueva estructura operativa.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img46.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Habilidades y estructuras
              p.mb-0 Se enfoca en la identificación y fortalecimiento de las habilidades y estructuras necesarias, incluyendo la gobernanza, la toma de decisiones compartidas, el entrenamiento en interacciones empáticas, el desarrollo de equipos de salud y la expansión de contenidos de educación e investigación.
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-1.d-lg-block.d-none
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img47.svg" alt="Imagen decorativa")
      .col-lg-11
        p.mb-0 Con lo anterior, la atención centrada en la persona, crea ambientes saludables en el trabajo, mejora los resultados de salud y compromete a las comunidades en torno a la salud y el bienestar: asimismo, tiene efecto en el desempeño directo de las organizaciones de salud y mejora la experiencia de la persona, es decir cada integrante se siente valorado y con ello la institución se consolida.
    
    .row.justify-content-center.align-items-center.mb-4
        .col-lg-4.col-6.mb-4.mb-lg-0
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img48.jpg" alt="Icono 1")
        .col-lg-8.mb-4.mb-lg-0
          p.mb-4  Las siguientes son las contribuciones del modelo:
          ul.lista-ul
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Mejora el estado de salud de forma más rápida.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Aumenta el nivel de excelencia de la calidad de la atención.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Incrementa la fidelidad en la organización por parte de la persona, familia y comunidad.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Aumenta el clima organizacional, fortaleciendo la satisfacción, liderazgo y compromiso del personal de salud; asimismo, en la satisfacción del sujeto de cuidado, su red de apoyo y comunidad.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 La eficacia en el uso de los recursos que dispone las organizaciones de salud, mejora el flujo de ingresos y su funcionamiento.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Impulsa el mejoramiento continuo de la calidad de la atención.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Brinda cercanía y conexión de la comunidad con la organización.
    .tarjeta.color-acento-botones.p-3.mb-4(data-aos="fade-right")
      .row.justify-content-around.align-items-center
        .col-3.col-sm-2.col-lg-1
          img(src="@/assets/curso/temas/tema3/img49.svg")
        .col
          .row.justify-content-between.align-items-center
            .col.mb-sm-0.mb-4
              h3.mb-1 Modelo Planetree
              p Este video presenta la ponencia de la directora de Planetree internacional, quien expone de manera clara su modelo.
            .col-sm-auto
              a.boton.color-acento-botones(:href="('https://www.youtube.com/watch?v=9DImhwsbHw4')" target="_blank" type="video")
                span Abrir video
                i.fas.fa-file-download

    separador
    #t_3_3.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  3.3	Experiencias en Colombia
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-1.d-lg-block.d-none
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img50.svg" alt="Imagen decorativa")
      .col-lg-11
        p.mb-0 Las habilidades para la vida se desarrollan y manifiestan en diversos escenarios —político, organizacional, social, económico, cultural, ético y tecnológico— y, en el ámbito institucional, se formalizan a través de lineamientos gerenciales, como las políticas de humanización que fortalecen la cultura organizacional. En este contexto, a continuación, se presentan experiencias desarrolladas en Colombia, en las que convergen estas características y se traducen en estrategias orientadas a la implementación de modelos de atención humanizada, centrados en la persona y en el reconocimiento de la dignidad humana:
    
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Programa de humanización ESE - La Mesa
    p.mb-4 Se presenta el programa de humanización en una Empresa Social del Estado (ESE) ubicada en La Mesa (Cundinamarca), que conforma estrategias, esfuerzos, actividades y proyecciones de atención centrada en la persona.

     .row.justify-content-center.align-items-center.mb-5
      .col-lg-12
        figure(data-aos="zoom-in")
          .video
            iframe(width="1346" height="757" src="https://www.youtube.com/embed/dpNebBasxoM" title="Programa Humanización V6" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)
            
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Estrategia aplicada ESE- La Mesa
    p.mb-4 Se presenta una de las estrategias utilizadas para abordar el programa de humanización en una Empresa Social del Estado ubicada en La Mesa (Cundinamarca). El apoyo emocional como eje de abordaje.

     .row.justify-content-center.align-items-center.mb-5
      .col-lg-12
        figure(data-aos="zoom-in")
          .video
            iframe(width="1346" height="757" src="https://www.youtube.com/embed/-PRXdjjUV-M" title="Estrategia Apoyo Emocional - Trabajo Social" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)
            
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Programa de humanización ESE Sesquilé
    p.mb-4 Se presenta una de las estrategias utilizadas para abordar el programa de humanización en tiempos de COVID por una ESE de Sesquilé (Cundinamarca).

    .row.justify-content-center.align-items-center
      .col-lg-12
        figure(data-aos="zoom-in")
          .video
            iframe(width="1346" height="757" src="https://www.youtube.com/embed/3PC_LdYwi6A" title="Humanización Hospital Sesquilé" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)
           
</template>
<script>
export default {
  name: 'Tema3',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
